import Framework from 'framework';

let nearestClubStore = {
	name: 'nearestClubStore',
	listen: (callback) => {
		return window.ef.nearestClubStore.listen((efData) => {
			// legacy callers look for `query`
			if (efData.queryText) {
				efData.query = efData.queryText;
			} else if (efData.queryObject) {
				efData.query = efData.queryObject;
			}
			callback(efData)
		});
	},
	getInitialData: () => {
		const efData = window.ef.nearestClubStore.getInitialData();
		// legacy callers look for `query`
		if (efData.queryText) {
			efData.query = efData.queryText;
		} else if (efData.queryObject) {
			efData.query = efData.queryObject;
		}
		return efData;
	},

	searchForNearestClub: (query, limit, distance, searchSource) => {
		if(query == null || query === '') {
			return false;
		}

		const payload = {
			queryText: typeof query === 'string'
				? query
				: '',
			queryObject: {},
			clubs: [],
			pending: true,
			projectedQuery: {
				latitude: null,
				longitude: null,
				limit: null,
				distance: null
			},
			bounds: {},
			stateSearch: false,
			initialized: false,
			queryLimit: limit || null,
			queryDistance: distance || null,
			querySource: searchSource
		};

		if(query.latitude && query.longitude){
			payload.queryObject.latitude = query.latitude;
			payload.queryObject.longitude = query.longitude;
		}

		if(query.bounds) {
			payload.queryObject.bounds = query.bounds;
		}

		if(query.stateSearch) {
			payload.queryObject.stateSearch = query.stateSearch;
		}

		return window.ef.nearestClubStore.searchForNearestClubs(payload);
	}
};

Framework.registerStore(nearestClubStore.name, nearestClubStore);

export default nearestClubStore;
